<div bsModal #modalMessage="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-{{size}}" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" (click)="onClickClose()" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="text-center modal-title" style="text-align: center !important;">{{title}}</h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-xs-12">
                        <h4>{{message}}</h4>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button style="margin-left: 0;" *ngIf="!hideClose" type="button" class="btn btn-border-orange pull-left" data-dismiss="modal" (click)="onClickClose()">{{labelClose}}</button>
                <button style="margin-right: 0;" *ngIf="!hideOk" type="button" class="btn btn-full-orange pull-right" (click)="onClickOk()" data-dismiss="modal">{{labelOk}}</button>
            </div>
        </div>
    </div>
</div>
